<template>
  <div class="keyAreaMonitor" ref="keyAreaMonitor">
    <div class="tltle">
      <div @click="watchAll()" class="lookAll">查看全部</div>
    </div>
    <div
      class="videoBox"
      v-loading="loading"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
    >
      <el-carousel
        indicator-position="outside"
        :autoplay="true"
        :initial-index="1"
        :interval="10000"
      >
        <el-carousel-item v-for="(item, i) in videoMap" :key="i">
          <ul clas="videoBar">
            <li
              @click="watchVideo(item_)"
              class="videoPic"
              v-for="(item_, j) in item.list"
              v-bind:key="j"
            >
              <template
                v-if="
                  (item_.cameraType === 'newEasyNvr' ||
                    isEasyNvr ||
                    isEasyCvr) &&
                  item_.picUrl
                "
              >
                <img :src="item_.picUrl" />
                <p>{{ item_.cameraName }}</p>
              </template>
              <template v-else>
                <img
                  :src="'/himg/' + item_.nvrIp + '/' + item_.channelId + '.jpg'"
                />
                <p>{{ item_.cameraName }}</p>
              </template>
            </li>
          </ul>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import axios from "axios";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      pageInfo: 'keyAreaMonitor(new).vue',
      computedName: '重点区域监控组件',
      customerId: this.$store.state.customerId,
      timer2: null,
      videoList: [],
      videoMap: [],
      channelsObj: "",
      channelsIds: "",
      videoBaseUrl: bmeConfig.easyNvrUrl,
      isEasyCvr: false,
      isEasyNvr: false,
      loading: true,
      telecomBxUrl: bmeConfig.telecomBxUrl || "",
    };
  },
  inject: ["updateNvrInfo"],
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.isEasyCvr = bmeConfig.isEasyCvr;
    this.isEasyNvr = bmeConfig.isEasyNvr;
    let that = this;
    let w = $(that.$refs.keyAreaMonitor).outerWidth();
    let h = $(that.$refs.keyAreaMonitor).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    if (bmeConfig.isEasyCvr) {
      //that.getCameraClassify();
      this.getEasyCvrList(function () {
        that.getCameraClassify();
      });
    } else {
      this.getEasyNvrList(function () {
        that.getCameraClassify();
      });
    }
    if (bmeConfig.isTelecomBX) {
      this.getTelecomBxList(function () {
        that.getCameraClassify();
      });
    } else if (bmeConfig.isTelecomSH) {
      this.getTelecomShList(function () {
        that.getCameraClassify();
      });
    }
  },
  //方法集合
  methods: {
    getEasyCvrList(cb) {
      let that = this;
      axios
        .get(
          "/api/v1/login?username=easycvr&password=5cdecdb8e87a0db1fe6e35555a870ae5",
          {}
        )
        .then((res) => {
          let ts = new Date().getTime();
          let token = res.data.EasyDarwin.Body.Token;
          window.easyAxiosToken = token;
          let getUrl = bmeConfig.cvrNewApi
            ? "/api/v1/devicesconfig?start=0&limit=9999"
            : "/api/v1/devices?start=0&limit=9999";
          axios
            .get(getUrl, {
              params: { token: window.easyAxiosToken },
            })
            .then((res) => {
              if (res.data.EasyDarwin.Header.ErrorNum == 200) {
                that.channelsObj = {};
                that.channelsIds = {};
                let devices = res.data.EasyDarwin.Body.Devices;
                devices.forEach((item) => {
                  let tmpDeviceIp = item.DeviceIp
                    ? item.DeviceIp
                    : item.DeviceName;
                  let tmpChannels = item.channels;
                  tmpChannels.forEach((item_) => {
                    let tmpChannelID = item_.Name;
                    that.channelsObj[tmpDeviceIp + "_" + tmpChannelID] =
                      item_.SnapUrl;
                    that.channelsIds[tmpDeviceIp + "_" + tmpChannelID] =
                      item_.ChannelID;
                  });
                });

                console.log(that.channelsObj, cb);
                if (cb) {
                  cb();
                }
              }
            })
            .catch((err) => {
              console.log(err);
              if (cb) {
                cb();
              }
            });
        })
        .catch((err) => {
          console.log(err);
          if (cb) {
            cb();
          }
        });
    },
    getEasyNvrList(cb) {
      let that = this;
      axios
        .get(
          "/api/v1/login?username=easynvr&password=ec6206d95f5772323792621ad25ffedf",
          {}
        )
        .then((res) => {
          let token = res.data.EasyDarwin.Body.Token;
          window.easyAxiosToken = token;
          let that = this;
          let ts = new Date().getTime();
          let getUrl = "/api/v1/getchannels?_=" + ts;
          axios
            .get(getUrl, {
              params: { token: window.easyAxiosToken },
            })
            .then((res) => {
              if (res.data.EasyDarwin.Header.ErrorNum == 200) {
                let channels = res.data.EasyDarwin.Body.Channels;
                that.channelsObj = {};
                channels.forEach((item) => {
                  that.channelsObj[item.Name] = item.SnapURL;
                });
                /*this.videoData.forEach((x1, i1) => {
                  x1.list.forEach((x2, i2) => {
                    x2["picUrl"] =
                      "http://localhost:10800" +
                      channelsObj[x2.nvrIp + "_" + x2.channelId];
                  });
                });*/
                //that.getList(channelsObj);
                if (cb) {
                  cb();
                }
              }
            })
            .catch((err) => {
              console.log(err);
              if (cb) {
                cb();
              }
            });
        })
        .catch((err) => {
          console.log(err);
          if (cb) {
            cb();
          }
        });
    },
    getTelecomBxList(cb) {
      axios
        .post(this.telecomBxUrl + "/vic/v1/auth/login", {
          account: "vic-sys-maint",
          password: "aa3441353445eb9c4832848a77d7a464",
        })
        .then((res) => {
          let token = res.data.token;
          window.telecombxAxiosToken = token;
          if (cb) {
            cb();
          }
        })
        .catch((err) => {
          console.log(err);
          if (cb) {
            cb();
          }
        });
    },
    getTelecomShList(cb) {
      if (cb) {
        cb();
      }
    },
    watchAll() {
      // this.$store.commit("changeVideoSquareSwitch", "open");
      if (bmeConfig.isQiniuyunRtc) {
        this.$store.commit("changeVideoSquareNewSwitch", "open");
      } else {
        this.$store.commit("changeVideoSquareSwitch", "open");
      }
    },
    watchVideo(item) {
      let that = this;
      //debugger;
      if (bmeConfig.isQiniuyunRtc) {
        this.$store.commit("changeVideoSquareNewSwitch", "open");
      } else {
        this.$store.commit("changeVideoPlayerSwitch", "open");
      }
      this.updateNvrInfo(item);
    },
    getCameraClassify() {
      let that = this;
      let videoMapList = [];
      this.loading = true;
      let findVideoMonitoringUrl =
        CONFIG.requestName + that.$apiOpt.findVideoMonitoring;
      that.$apiUtils
        .get(findVideoMonitoringUrl, {
          customerId: that.$store.state.customerId,
          isMore: true,
        })
        .then(function (data) {
          data.forEach((item) => {
            item.len = item.list && item.list.length > 0 ? item.list.length : 0;
          });
          data = data.sort(function (a, b) {
            return b.len - a.len;
          });

          let max = data.length > 4 ? 4 : data.length;
          for (let i = 0; i < max; i++) {
            let tmpObj = new Object();
            for (let j in data[i]) {
              if (j === "list") {
                tmpObj.list = [];
              } else {
                tmpObj[j] = data[i][j];
              }
            }

            let tmpMax =
              data[i].list && data[i].list.length > 0 ? data[i].list.length : 0;
            for (let j = 0; j < tmpMax; j++) {
              tmpObj.list.push(data[i].list[j]);
            }
            videoMapList.push(tmpObj);
          }

          if (that.channelsObj) {
            videoMapList.forEach((x1, i1) => {
              x1.list.forEach((x2, i2) => {
                if (
                  x2.cameraType === "newEasyNvr" ||
                  bmeConfig.isEasyNvr ||
                  bmeConfig.isEasyCvr
                ) {
                  x2["picUrl"] = that.channelsObj
                    ? that.channelsObj[x2.ipAddress]
                      ? that.videoBaseUrl + that.channelsObj[x2.ipAddress]
                      : that.videoBaseUrl +
                        that.channelsObj[x2.nvrIp + "_" + x2.channelId]
                    : "";
                  x2["recordeId"] =
                    that.channelsIds[x2.nvrIp + "_" + x2.channelId];
                }
              });
            });
          }

          that.videoMap = videoMapList;
          console.log("video", that.videoMap);
          that.loading = false;
          that.$forceUpdate();
          that.$nextTick(() => {
            if ($(".keyAreaMonitor .videoBox .el-carousel__button")[0]) {
              $(".keyAreaMonitor .videoBox .el-carousel__button")[0].click();
            }
          });
        });
    },
  },
};
</script>
<style lang="scss">
.keyAreaMonitor {
  .el-carousel__container {
    height: 160px;
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }
  .el-carousel__item:nth-child(2n) {
    background-color: none;
  }
  .el-carousel__item:nth-child(2n + 1) {
    background-color: none;
  }
}
</style>
<style lang="scss" scoped="scoped">
.keyAreaMonitor {
  width: 600px;
  height: 250px;
  .tltle {
    display: flex;
    position: relative;
    width: 100%;
    height: 24px;
    justify-content: flex-end;
    .home_number {
      margin-right: 290px;
    }
    .lookAll {
      cursor: pointer;
      margin-right: 21px;
      height: 24px;
      font-size: 18px;
      color: #4be0ff;
      line-height: 24px;
    }
  }
  .videoBox {
    //@include bg-box(558px, 172px, "movie.png");
    cursor: pointer;
    white-space: nowrap;
    //display: flex;
    //padding-top: 15px;
    margin: 0 auto;
    margin-top: 10px;
    .video1 {
      width: 274px;
      height: 142px;
      margin-right: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .video2 {
      width: 274px;
      height: 142px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .videoBar {
    height: 100%;
  }
  .videoPic {
    position: relative;
    width: 140px;
    height: 80px;
    float: left;

    img {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
    }

    p {
      position: absolute;
      width: 100%;
      bottom: 5px;
      text-align: center;
      left: 0px;
      text-overflow: ellipsis;
      overflow: hidden;
      padding: 0 5px;
    }
  }
}
</style>
